import { render, staticRenderFns } from "./GaaOrders.vue?vue&type=template&id=38b3bb68"
import script from "./GaaOrders.vue?vue&type=script&lang=js"
export * from "./GaaOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports